import { PixNotification } from "../../master/pix/models/notification.model";

export class DetailNotification {

	notificationId: number;
	messageTitle: any;
	messageContent: any;
	date: string;
	buttonDescription: any;
	buttonLink: any;
	pixNotification: PixNotification

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/models/detail-notification.ts